import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

interface ProtectedRouteProps {
    children: React.ReactNode;
}



const PrivateRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const token = localStorage.getItem("token");
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const location = useLocation();
    const needsEditProfile = localStorage.getItem("nep") == "true";
 

    if (!token || !(userData?.role?.roleName === "shopper" || userData.role == 4)) {
        return <Navigate to="/login" replace />;
    }

    if (((localStorage.getItem("ng") || needsEditProfile) && location.pathname !== "/dashboard/myprofile")) {
        return <Navigate to="/dashboard/myprofile" replace />;
    }

    return <>{children}</>;
};

export default PrivateRoute;
